export enum ColorVariables {
    BACKGROUND_DARK = 10,
    BACKGROUND_LIGHT = 99,
    
    ERROR_DARK = 80,
    ERROR_LIGHT = 40,
    
    ERROR_CONTAINER_DARK = 30,
    ERROR_CONTAINER_LIGHT = 90,
    
    INVERSE_ON_SURFACE_DARK = 20,
    INVERSE_ON_SURFACE_LIGHT = 95,
    
    INVERSE_PRIMARY_DARK = 40,
    INVERSE_PRIMARY_LIGHT = 80,
    
    INVERSE_SURFACE_DARK = 90,
    INVERSE_SURFACE_LIGHT = 20,
    
    ON_BACKGROUND_DARK = 90,
    ON_BACKGROUND_LIGHT = 10,
    
    ON_ERROR_DARK = 20,
    ON_ERROR_LIGHT = 100,
    
    ON_ERROR_CONTAINER_DARK = 90,
    ON_ERROR_CONTAINER_LIGHT = 10,
    
    ON_PRIMARY_DARK = 20,
    ON_PRIMARY_LIGHT = 100,
    
    ON_PRIMARY_CONTAINER_DARK = 90,
    ON_PRIMARY_CONTAINER_LIGHT = 10,
    
    ON_PRIMARY_FIXED = 10,
    
    ON_PRIMARY_FIXED_VARIANT = 30,
    
    ON_SECONDARY_DARK = 20,
    ON_SECONDARY_LIGHT = 100,
    
    ON_SECONDARY_CONTAINER_DARK = 90,
    ON_SECONDARY_CONTAINER_LIGHT = 10,
    
    ON_SECONDARY_FIXED = 10,
    
    ON_SECONDARY_FIXED_VARIANT = 30,
    
    ON_SURFACE_DARK = 90,
    ON_SURFACE_LIGHT = 10,
    
    ON_SURFACE_VARIANT_DARK = 90,
    ON_SURFACE_VARIANT_LIGHT = 30,
    
    ON_TERTIARY_DARK = 20,
    ON_TERTIARY_LIGHT = 100,
    
    ON_TERTIARY_CONTAINER_DARK = 90,
    ON_TERTIARY_CONTAINER_LIGHT = 10,
    
    ON_TERTIARY_FIXED = 10,
    
    ON_TERTIARY_FIXED_VARIANT = 30,
    
    OUTLINE_DARK = 60,
    OUTLINE_LIGHT = 50,
    
    OUTLINE_VARIANT_DARK = 30,
    OUTLINE_VARIANT_LIGHT = 80,
    
    PRIMARY_DARK = 80,
    PRIMARY_LIGHT = 40,
    
    PRIMARY_CONTAINER_DARK = 30,
    PRIMARY_CONTAINER_LIGHT = 90,
    
    PRIMARY_FIXED = 90,
    
    PRIMARY_FIXED_DIM = 80,
    
    SCRIM_DARK = 0,
    SCRIM_LIGHT = 0,
    
    SECONDARY_DARK = 80,
    SECONDARY_LIGHT = 40,
    
    SECONDARY_CONTAINER_DARK = 30,
    SECONDARY_CONTAINER_LIGHT = 90,
    
    SECONDARY_FIXED = 90,
    
    SECONDARY_FIXED_DIM = 80,
    
    SHADOW_DARK = 0,
    SHADOW_LIGHT = 0,
    
    SURFACE_DARK = 6,
    SURFACE_LIGHT = 98,
    
    SURFACE_BRIGHT_DARK = 24,
    SURFACE_BRIGHT_LIGHT = 98,
    
    SURFACE_CONTAINER_DARK = 12,
    SURFACE_CONTAINER_LIGHT = 94,
    
    SURFACE_CONTAINER_HIGH_DARK = 17,
    SURFACE_CONTAINER_HIGH_LIGHT = 92,
    
    SURFACE_CONTAINER_HIGHEST_DARK = 24,
    SURFACE_CONTAINER_HIGHEST_LIGHT = 90,
    
    SURFACE_CONTAINER_LOW_DARK = 10,
    SURFACE_CONTAINER_LOW_LIGHT = 96,
    
    SURFACE_CONTAINER_LOWEST_DARK = 4,
    SURFACE_CONTAINER_LOWEST_LIGHT = 100,
    
    SURFACE_DIM_DARK = 6,
    SURFACE_DIM_LIGHT = 87,
    
    SURFACE_TINT_DARK = 80, //primary
    SURFACE_TINT_LIGHT = 40, // primary
    
    SURFACE_VARIANT_DARK = 30, //neutral variant
    SURFACE_VARIANT_LIGHT = 90, //neutral variant
    
    TERTIARY_DARK = 80,
    TERTIARY_LIGHT = 40,
    
    TERTIARY_CONTAINER_DARK = 30,
    TERTIARY_CONTAINER_LIGHT = 90,
    
    TERTIARY_FIXED = 90,
    
    TERTIARY_FIXED_DIM = 80,
  }
  